export const initialState = {
  props: {
    modalType: '',
  },
  open: false,
}
